import { createFileRoute } from '@tanstack/react-router';
import { PersonDraftsRoute } from './-route-wrappers';

/** The person profile's Drafts tab at its own URL (FPS-2712). */
function PersonDraftsIndexRoute() {
  const { personId } = Route.useParams();

  return <PersonDraftsRoute personId={personId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/$personId/drafts/')({
  component: PersonDraftsIndexRoute,
});
